import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CaseFormSectionContainerComponent } from "../forms/case-form-section-container/case-form-section-container.component";
import { NewsArticle, RelatedNewsArticle } from 'app/profile/news/news-profile.model';
import { SelectFormFieldComponent } from "../forms/fields/select-form-field/select-form-field.component";
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-related-news',
  standalone: true,
  imports: [TranslateModule, FormsModule, RouterModule, CommonModule, CaseFormSectionContainerComponent, SelectFormFieldComponent, ReactiveFormsModule, NgSelectModule],
  templateUrl: './related-news.component.html',
  styleUrl: './related-news.component.scss'
})
export class RelatedNewsComponent implements OnInit, OnChanges {
  @Input() form!: FormGroup;
  @Input() newsItems: NewsArticle[] = [];
  @Input() isViewMode: boolean = false;
  @Input() addNewsRow!: number;
  @Output() addRelatedNews = new EventEmitter<number[]>();
  @Output() deleteRelatedNews = new EventEmitter<number>();
  @Output() viewRelatedNews = new EventEmitter<number>();
  @Output() selectRelatedNews = new EventEmitter<number>();

  @Input() relatedNews: RelatedNewsArticle[] = [];
  showDropdown = false;
  availableNewsItems: any = [];

  ngOnInit(): void {
    this.updateAvailableNewsItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['newsItems'] || changes['relatedNews']) {
      this.updateAvailableNewsItems();
    }

    if (changes['addNewsRow'] && !changes['addNewsRow'].firstChange) {
      this.showDropdown = true;
    }
  }

  updateAvailableNewsItems(): void {
    this.availableNewsItems = this.getAvailableNewsItems();
  }

  onRelatedNewsClick(newsId: number) {
    this.viewRelatedNews.emit(newsId);
  }


  getAvailableNewsItems() {
    return this.newsItems
      .filter(news => !this.relatedNews.some(selected => selected.id === news.id))
      .map(news => ({ id: news.id, title: news.title }));
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onSelectRelatedNews(event: any): void {
    const selectedNewsId = event?.id;

    if (!selectedNewsId) {
      return;
    }

    const selectedNews = this.newsItems.find(news => news.id === selectedNewsId);
    if (selectedNews && !this.relatedNews.some(news => news.id === selectedNewsId)) {
      const relatedNewsArticle: RelatedNewsArticle = {
        id: selectedNews.id,
        title: selectedNews.title,
        shortBody: selectedNews.shortBody,
        autorName: selectedNews.autorName,
        publishDate: selectedNews.publishDate instanceof Date
          ? selectedNews.publishDate.toISOString()
          : selectedNews.publishDate,
        viewsCount: selectedNews.viewsCount,
      };

      this.relatedNews.push(relatedNewsArticle);
      this.addRelatedNews.emit([selectedNewsId]);

    }

    this.showDropdown = false;
    this.form.get('relatedNewsDropdown')?.reset();
    this.selectRelatedNews.emit();
  }

  deleteNews(index: number): void {
    const removedNewsId = this.relatedNews[index].id;
    this.relatedNews.splice(index, 1);
    this.deleteRelatedNews.emit(removedNewsId);
  }
}
